/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext, useEffect, useState} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useSnackbar} from "notistack";
import {useIntl} from "react-intl";

const useLoadCourse = (courseKey) => {

    const [course, setCourse] = useState()
    const [loading, setLoading] = useState(true)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Retrieving the already existing course
    const fetchCourseData = async () => {
        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/courses/' + courseKey + '?idToken=' + idToken)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                const courseJson = await data.json();
                setCourse(courseJson)
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.courses.messages.load.course.error',
                        defaultMessage: 'Something went wrong while loading the course: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        fetchCourseData()
    }, [])


    return {
        loading,
        course
    }
}
export default useLoadCourse;